module.exports = __webpack_public_path__ + "img/1546290086.461840fd.jpg";